var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.permissions.hasRead
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-new": false,
              "show-delete": false,
              "show-save": false,
              "show-print": false,
              "show-cancel": true,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("quote-template-side-menu"),
                _c("quote-template-setting-menu", {
                  on: { getQuoteTemplate: _vm.getQuoteTemplate },
                }),
                _c("app-side-menu", [
                  _c(
                    "aside",
                    {
                      staticClass: "menu",
                      attrs: { slot: "side-menu" },
                      slot: "side-menu",
                    },
                    [
                      _c("quote-template-tags", {
                        attrs: {
                          tags: _vm.tags,
                          "tag-category-id": _vm.tagCategory.tagCategoryID,
                          "selected-tags": _vm.selectedTagIDs,
                        },
                        on: { "toggle-tag": _vm.toggleTag },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "column m-3" }, [_c("router-view")], 1),
          ]),
        ],
        1
      )
    : _c("div", [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "is-flex is-justify-content-center pt-5" },
      [
        _c("div", { staticClass: "notification is-danger is-flex is-size-4" }, [
          _vm._v(" You do not have permissions on this page "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }